// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderRequestSearchBase {
    static getAttributeTypeMap() {
        return PharmacyCardFinderRequestSearchBase.attributeTypeMap;
    }
}
PharmacyCardFinderRequestSearchBase.discriminator = undefined;
PharmacyCardFinderRequestSearchBase.additionalProperties = false;
PharmacyCardFinderRequestSearchBase.attributeTypeMap = [
    {
        "name": "request",
        "baseName": "request",
        "type": "PharmacyCardFinderRequestBase"
    },
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
    {
        "name": "transactionDateTime",
        "baseName": "transactionDateTime",
        "type": "Date"
    },
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "string"
    },
    {
        "name": "transactionMessage",
        "baseName": "transactionMessage",
        "type": "string"
    },
    {
        "name": "transactionStatus",
        "baseName": "transactionStatus",
        "type": "boolean"
    },
];
//# sourceMappingURL=pharmacyCardFinderRequestSearchBase.js.map